import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CountryResponse } from "../models/country";

@Injectable({
  providedIn: "root",
})
export class CountryService {
  private apiUrl = "../../assets/countries.json";

  constructor(private http: HttpClient) {}

  getCountries(): Observable<CountryResponse> {
    return this.http.get<CountryResponse>(this.apiUrl);
  }
}
